export default "__VITE_ASSET__67bc350e__"